<template>
  <ItemRow>
    <ItemWithLabel
      :column="columns[0]"
    >
      <PasswordManagerUsernameLink
        :id="itemData.id"
        :userFullName="itemData.name"
        :username="itemData.username"
      />
    </ItemWithLabel>
    <ItemWithLabel
      :column="columns[1]"
    >
      {{ itemData.email }}
    </ItemWithLabel>

    <ItemWithLabel
      :column="columns[2]"
    >
      {{ itemData.accessLevelName }}
    </ItemWithLabel>
    <ItemWithLabel
      class="actionsColumn"
      :column="columns[3]"
    >
      <DropdownActions
        buttonText="Actions"
        class="drowpdowActions"
        :items="dropdownItems"
        position="right"
      >
        <template v-slot:button="dropdown">
          <IconButton
            ariaLabel="actions"
            hasNoBackground
            icon="more"
            @click="dropdown.defaults.click()"
          />
        </template>
      </DropdownActions>
    </ItemWithLabel>
    <SharedFolderAccessLevelModal
      v-if="isAccessLevelModalVisible"
      :accessLevelId="itemData.accessLevelId"
      @close="handleCloseAccessLevelModal"
      @save="handleSaveAccessLevel"
    />
    <SharedFolderRevokeConfirmationModal
      v-if="isRevokeConfirmationModalVisible"
      :title="$options.revokeAccessTitle"
      @close="handleCloseRevokeModal"
      @revokeAccess="handleConfirmRevoke"
    />
  </ItemRow>
</template>

<script>
import {
  DropdownActions,
  IconButton,
  ItemRow,
  ItemWithLabel,
  Types,
} from '@jumpcloud/ui-components';
import { mapActions } from 'vuex';
import { notificationModuleName as notificationModule } from '@jumpcloud/ui-notifications';
import PasswordManagerUsernameLink from 'client/PasswordManager/components/PasswordManagerUsernameLink.vue';
import SharedFolderAccessLevelModal from 'client/PasswordManager/SharedFolders/SharedFolderAccessLevelModal.vue';
import SharedFolderRevokeConfirmationModal from 'client/PasswordManager/SharedFolders/SharedFolderRevokeConfirmationModal.vue';

const { DropdownMenuItem } = Types;
const sharedFolderSystemUserCollection = 'SharedFolderSystemUserCollection';

export default {
  name: 'SharedFolderSystemUserRow',

  components: {
    DropdownActions,
    IconButton,
    ItemRow,
    ItemWithLabel,
    PasswordManagerUsernameLink,
    SharedFolderAccessLevelModal,
    SharedFolderRevokeConfirmationModal,
  },

  revokeAccessTitle: 'The user will lose access to all items in this folder. Only users with the \'folder manager\' permission can re-add the user to the folder.',

  props: {
    columns: {
      default: () => ([]),
      type: Array,
    },

    itemData: {
      required: true,
      type: Object,
    },
  },

  data() {
    return {
      dropdownItems: [
        DropdownMenuItem({
          click: this.showAccessLevelModal,
          text: 'Change Access Level',
        }),
        DropdownMenuItem({
          click: this.showRevokeModal,
          text: 'Revoke Access',
        })],
      isAccessLevelModalVisible: false,
      isRevokeConfirmationModalVisible: false,
    };
  },

  methods: {
    ...mapActions(notificationModule, [
      'triggerErrorNotification',
      'triggerSuccessNotification',
    ]),

    ...mapActions(sharedFolderSystemUserCollection, [
      'updateAccessLevel',
      'revokeAccessLevels',
    ]),

    handleCloseAccessLevelModal() {
      this.isAccessLevelModalVisible = false;
    },

    handleCloseRevokeModal() {
      this.isRevokeConfirmationModalVisible = false;
    },

    async handleConfirmRevoke() {
      try {
        this.isLoading = true;
        await this.revokeAccessLevels(this.itemData.id);
        this.isRevokeConfirmationModalVisible = false;
        this.triggerSuccessNotification({ title: 'Saved', message: 'User access has been revoked successfully.' });
      } catch (error) {
        this.triggerErrorNotification({
          title: 'Error',
          message: error?.message || 'There was a problem revoking user access. Please try again.',
        });
      } finally {
        this.isLoading = false;
      }
    },

    async handleSaveAccessLevel(accessLevelId) {
      try {
        this.saving = true;
        await this.updateAccessLevel({ userId: this.itemData.id, accessLevelId });
        this.isAccessLevelModalVisible = false;
        this.triggerSuccessNotification({ title: 'Saved', message: 'User access level changed successfully.' });
      } catch (error) {
        this.triggerErrorNotification({
          title: 'Error',
          message: error?.response?.data?.message || 'There was a problem changing user access level. Please try again.',
        });
      } finally {
        this.saving = false;
      }
    },

    showAccessLevelModal() {
      this.isAccessLevelModalVisible = true;
    },

    showRevokeModal() {
      this.isRevokeConfirmationModalVisible = true;
    },

  },
};
</script>

<style scoped>
.actionsColumn.actionsColumn {
  display: flex;
  justify-content: flex-end;
  overflow: visible;
}

.drowpdowActions.drowpdowActions {
  --dropdown-menu-width: 12rem;

  z-index: auto;
}
</style>
